<!-- misToolTip  [text]="'Number of shifts'" [position]="'bottom'"  TOOL TIP CDS -->

<!-- Employee Card -->
<div *ngFor="let employee of employees" class="employee-card d-flex " [ngStyle]="{background:activeBg?'#FFF5DA':''}">
    <!-- <div class="card-child-1"><span class="h8"></span></div> -->
    <div class="card-child-2">
        <img *ngIf="employee.StopActualArrivalTime > 0" src="{{imgSrc}}assets/icons/active-rectangle1.svg">
        <img *ngIf="employee.StopActualArrivalTime == 0" src="{{imgSrc}}assets/icons/inactive-rectangle1.svg">
    </div>
    <div class="card-child-3 d-flex flex-dir-col just-space" style="padding:10px 0;border-bottom: 1px solid lightgray;">
        <div class="up d-flex just-space">
            <div class="up-child-1 d-flex align-center flex-dir-rol gap-8">
                <div class="avtar d-flex align-center just-center">
                    <span class="h6-b">{{employee?.name[0]}}</span>
                </div>
                <div class="d-flex flex-dir-col">
                    <span class="h7-b">{{employee.employeeId}}</span>
                    <!-- <span class="h8 grey">{{employee.employeeId}} . {{employee.gender}}</span> -->
                </div>
                <img src="{{imgSrc}}assets/icons/Ellipse.svg" />
                <img misToolTip [text]="'Male'" *ngIf="employee.gender==='Male'"
                    src="{{imgSrc}}assets/icons/male-emp.svg" />
                <img misToolTip [text]="'Female'" *ngIf="employee.gender==='Female'"
                    src="{{imgSrc}}assets/icons/female-emp.svg" />
                <img *ngIf="employee.noShow" src="{{imgSrc}}assets/icons/Ellipse.svg" />
                <div *ngIf="employee.noShow" class="pr-16">
                    <img src="{{imgSrc}}assets/icons/no-show2.svg" alt="">
                </div>
            </div>
            <div class="d-flex gap-8" style="padding-right: 18px">
                <div class="attendance-action" *ngIf="isAllowSignoutEmployeesOnTripView() && !employee?.actualPickupTime && !employee?.noShow && !isTripCompleted() ">
                    <img src="{{imgSrc}}assets/icons/signin-action.svg" style="cursor: pointer;" width="16" height="16" alt="Sign In Icon"
                    misToolTip [text]="'Click on the icon to sign in the employee'" [position]="'right'"
                    (click)="updateAttendance(employee,AttendanceAction.SIGNIN)"
                    class="cursor-pointer"
                    />
                </div>
                <div class="attendance-action" *ngIf="isAllowSignoutEmployeesOnTripView() && isSignedIn(employee)">
                    <img src="{{imgSrc}}assets/icons/signout-action.svg" style="cursor: pointer;" width="16" height="16" alt="Sign Out Icon"
                    misToolTip [text]="'Click on the icon to sign out the employee'" [position]="'right'"
                    (click)="updateAttendance(employee,AttendanceAction.SIGNOUT)"
                    class="cursor-pointer"
                    />
                </div>
                <img misToolTip [text]="'Employee Details'" [position]="'bottom'" style="cursor: pointer;"
                    (click)="openEmployeeDetails(employee)" src="{{imgSrc}}assets/icons/employee-info.svg" />


                <!-- <div class="d-flex gap-8">
                        <div class="d-flex gap-4">
                            <span class="h8 grey">Sign In </span>
                            <span class="h8">{{employee.signIn}}</span>
                        </div>
                        <div class="d-flex gap-4">
                            <span class="h8 grey">Sign Out </span>
                            <span class="h8">{{employee.signOut}}</span>
                        </div>
                    </div> -->


            </div>
        </div>
        <!-- <div class="down d-flex flex-dir-col">
            <span class="h9 grey">Planned Drop</span>
            <span misToolTip  [text]="employee.plannedPickUpLocation" [position]="'bottom'" style="width:197px" class="h8 truncate">{{employee.plannedPickUpLocation}}</span>
        </div> -->
    </div>

</div>